import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Target, Shield, Award } from 'lucide-react';

const AboutSection = ({ onOpenModal }) => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-emerald-50 via-teal-50 to-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative animate-fade-in">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl hover-zoom">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800"
                alt="Team collaboration"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/50 to-transparent"></div>
            </div>
            {/* Floating Card with animation */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-xl p-4 max-w-xs animate-float">
              <div className="flex items-center space-x-3 mb-2">
                <Award className="text-brand-primary animate-rotate-slow" size={24} />
                <span className="font-bold text-gray-800">Trusted legal expert support</span>
              </div>
              <p className="text-gray-600 text-sm">Professional Brand Protection Solutions Here</p>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-6 animate-slide-up">
            <div className="inline-block bg-emerald-100 px-4 py-2 rounded-full">
              <span className="text-emerald-700 font-semibold">ABOUT US</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight">
              Our Vision:{' '}
              <span className="bg-brand-gradient bg-clip-text text-transparent">
                Securing Your Success!
              </span>
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              At Trademark Law Associates, we are dedicated to protecting your brand's identity and ensuring its continued growth. With our expert team, we focus on identifying and preventing potential conflicts, giving you the peace of mind to thrive.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              From securing logos to safeguarding entire brands, we provide the protection you need for lasting success. Trust us to make your brand our priority.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-start space-x-3 group hover:translate-x-2 transition-transform">
                <div className="bg-emerald-100 p-2 rounded-lg group-hover:scale-110 transition-transform">
                  <Target className="text-brand-primary icon-bounce" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800">Expert Team</h4>
                  <p className="text-gray-600 text-sm">Experienced professionals at your service</p>
                </div>
              </div>
              <div className="flex items-start space-x-3 group hover:translate-x-2 transition-transform">
                <div className="bg-emerald-100 p-2 rounded-lg group-hover:scale-110 transition-transform">
                  <Shield className="text-brand-primary icon-bounce" size={24} />
                </div>
                <div>
                  <h4 className="font-bold text-gray-800">Full Protection</h4>
                  <p className="text-gray-600 text-sm">Comprehensive IP security solutions</p>
                </div>
              </div>
            </div>

            <Button
              size="lg"
              className="bg-brand-gradient text-white hover:opacity-90 group mt-6 shadow-lg hover:shadow-xl transition-all font-bold text-lg px-8 py-6"
              onClick={onOpenModal}
            >
              Get Started Now
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={24} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;